var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSailPointLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1983.03 703.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clss-1{fill:none;}.clss-2{fill:#0033a1;}.clss-3{fill:#cc27b0;}.clss-4{fill:#0071ce;}.clss-5{fill:#e17fd2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "clss-1",
    width: 1983.03,
    height: 703.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M647.77,356.45c-18.18-5.15-27.55-14.05-27.55-26.45,0-15.3,14-26.11,33.21-26.11,19.87,0,32.45,10.56,33.18,27.55h48.48c-.79-42.85-33.2-71.62-81.08-71.62s-82.64,30.05-82.64,71.5c0,32.87,20.88,55.92,62,68.71l29.72,8.27c22,6.3,31.12,14.9,30.6,29.35-.33,16.65-14.9,27.55-37.46,27.55-24.49,0-36.73-14.54-38.08-29.45h-49c.89,42.85,36.42,72.3,87.11,72.3,41,0,85.7-22,86.41-70.09,1-35-21.15-59.38-66-72.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M838.43,338.05a84.66,84.66,0,0,0,0,169.26c13.59,0,37.28-6.58,46.89-21.27l3.06-4.65V504h45.73V341.57H888.53v22l-3.06-4.32C871,338.66,841.7,338.05,838.43,338.05Zm4.89,125.71c-20.78,0-43.18-15.7-43.18-41s22.37-41,43.18-41,41.75,14.38,41.75,41-21.54,41-41.75,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1007.14,341.6h-45.7V504.16h45.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1080.72,263h-45.91V504.1h45.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1205.81,262.76H1107V504.1h49V419.62h49.92c58.16,0,78.94-42.15,78.94-78.32C1284.75,287.09,1245.11,262.76,1205.81,262.76Zm-2.51,114.71h-47.41V305.21h49c21.43,0,31.13,21.09,31.13,36.05,0,17.88-12.24,36.21-32.56,36.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1366,338.05c-48.82,0-84.27,35.44-84.27,84.3S1317,507,1366,507s84.47-35.6,84.47-84.63S1415,338.05,1366,338.05ZM1366,462a39.48,39.48,0,1,1,39.23-39.79A38.16,38.16,0,0,1,1368.76,462C1367.85,462,1366.93,462,1366,462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1513.67,341.6h-45.73V504.16h45.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1589.7,364.86l-3.06,5.82V341.57h-46.16v162.5h45.91V418c0-23.14,11.2-35.38,32.17-35.38,18.89,0,30.39,13.28,30.39,34.58V504H1695v-97.4c.21-44.23-20.75-68.71-58.83-68.71a53.48,53.48,0,0,0-46.49,26.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M984.27,318.49a28.53,28.53,0,1,0-28.46-28.59v.1A27.68,27.68,0,0,0,958,300.89a28.52,28.52,0,0,0,26.32,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1490.74,318.49a28.53,28.53,0,1,0-28.46-28.59v.1a27.68,27.68,0,0,0,2.14,10.89,28.51,28.51,0,0,0,26.32,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1814.24,341.48h-32V278.09h-45.91v63.39h-30.61v38.69h30.61V504.1h45.91V380.17h32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clss-2",
    points: "379.75 172.71 423.83 435.76 168.74 435.76 379.75 172.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clss-3",
    points: "379.75 172.71 535.98 435.76 423.83 435.76 379.75 172.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clss-4",
    points: "168.74 435.76 423.83 435.76 439.77 530.83 168.74 435.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "clss-5",
    points: "423.83 435.76 535.98 435.76 439.77 530.83 423.83 435.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-2",
    d: "M1826.4,473a16.77,16.77,0,0,1,6.3,6.48,18.8,18.8,0,0,1,2.3,9.27,18.53,18.53,0,0,1-2.3,9.22,16.87,16.87,0,0,1-6.3,6.44,17.75,17.75,0,0,1-9.13,2.34,18,18,0,0,1-9.18-2.34,16.79,16.79,0,0,1-6.35-6.44,18.52,18.52,0,0,1-2.29-9.22,18.79,18.79,0,0,1,2.29-9.27,16.69,16.69,0,0,1,6.35-6.48,18,18,0,0,1,9.18-2.34A17.75,17.75,0,0,1,1826.4,473Zm1.35,26.55a16.55,16.55,0,0,0,0-21.6,15.22,15.22,0,0,0-21.06,0,16.58,16.58,0,0,0,0,21.6,15.22,15.22,0,0,0,21.06,0Zm-3.91-11a6,6,0,0,1-3.51,1.94l5.4,7.74-4.59.09-5-7.65h-2.07v7.65h-3.87V478.92h8.37a6.8,6.8,0,0,1,4.72,1.57,5.47,5.47,0,0,1,1.76,4.28A5.56,5.56,0,0,1,1823.84,488.5Zm-9.72-1.12h4.23a3.27,3.27,0,0,0,2.07-.63,2.25,2.25,0,0,0,.81-1.89,2.13,2.13,0,0,0-.81-1.85,3.45,3.45,0,0,0-2.07-.58h-4.23Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailPointLogo);
export default __webpack_public_path__ + "static/media/SailPoint-Logo.762ccfee5680177bd2c1ced5b395c36d.svg";
export { ForwardRef as ReactComponent };